// extracted by mini-css-extract-plugin
module.exports = {"PanelContact":"styles_PanelContact__Pl0kN","title":"styles_title__6l3NQ","cta":"styles_cta__D8UpW","subtitle":"styles_subtitle__x03_e"};